import React from "react";
import { Theme } from "./lib/types";

interface ThemeStyleProps {
	theme?: Theme;
}

const ThemeStyle = (props: ThemeStyleProps) => {
	return (
		<style>
			:root {"{"}
			--primary-color: {props.theme ? props.theme.primaryColor : null};
			--secondary-color:
			{props.theme ? props.theme.secondaryColor : null}; font-size:
			{props.theme ? props.theme.rootFontSize : null};{"}"}
		</style>
	);
};

export { ThemeStyle };
